import React from "react";
import { timeframeOptions } from "../../../components/timeframeOptions";
import { handleTime } from "../../StudentData/handlers/timeHandler";
import { FaCalendar } from "react-icons/fa";

const TimeDropdown2 = ({ state, updateState }) => (
  <div className=" text-[14px] rounded p-2 border border-[#DDDDDD] flex-1 w-full h-full flex items-center relative">
    <FaCalendar className="ml-1 h-4 w-4 text-gray-600" />
    <select
      className="flex-1 px-2 w-full h-full bg-transparent appearance-none text-left focus:outline-none
        first:rounded-r-none last:rounded-l-none cursor-pointer rounded border-[#DDDDDD] "
      value={state.chosenTime}
      onChange={(e) => {
        updateState(handleTime(state, e.target.value, false, true));
      }}
    >
      {timeframeOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.display}
        </option>
      ))}
    </select>
    <div className="pointer-events-none absolute right-1 top-1/2 -translate-y-1/2 mr-1">
      <svg
        className="w-3 h-3 text-gray-600"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 10 6"
        fill="currentColor"
      >
        <path d="M0 0l5 6 5-6H0z" />
      </svg>
    </div>
  </div>
);

export default TimeDropdown2;
